// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"data-search"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M3 3H21V12H3V3Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M21.5 18.25C21.5 19.7688 20.2688 21 18.75 21C17.2312 21 16 19.7688 16 18.25C16 16.7312 17.2312 15.5 18.75 15.5C20.2688 15.5 21.5 16.7312 21.5 18.25Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M3 12H21V3H3V12ZM3 12L3 21.0004H12.5M3 12V11.998M6.99805 7.5H7.00195V7.50391H6.99805V7.5ZM6.99805 16.5H7.00195V16.5039H6.99805V16.5Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M22.25 21.75L20.6945 20.1945M21.5 18.25C21.5 19.7688 20.2688 21 18.75 21C17.2312 21 16 19.7688 16 18.25C16 16.7312 17.2312 15.5 18.75 15.5C20.2688 15.5 21.5 16.7312 21.5 18.25Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-data-search')
export default class DataSearchIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'data-search',
    }
  }
}
